import { createContext, useState, useEffect, useRef } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

   const [user, setUser] = useState(null);
   const [loading, setLoading] = useState(true);
   const logoutTimer = useRef(null);

   const logout = () => {
      if (logoutTimer.current) {
         clearTimeout(logoutTimer.current);
      }
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setUser(null);
   };

   useEffect(() => {
      const token = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");

      if (token && storedUser) {
         setUser(JSON.parse(storedUser));

         try {
            const decoded = jwtDecode(token);
            const expiryTime = decoded.exp * 1000;
            const currentTime = Date.now();

            if (expiryTime <= currentTime) {
               logout();
            } else {
               const timeout = expiryTime - currentTime;
               logoutTimer.current = setTimeout(() => {
                  logout();
               }, timeout);
            }
         } catch (err) {
            logout();
         }
      }

      setLoading(false);

      return () => {
         if (logoutTimer.current) {
            clearTimeout(logoutTimer.current);
         }
      };
   }, []); 

   const handleToken = (token) => {
      try {
         const decoded = jwtDecode(token);
         const expiryTime = decoded.exp * 1000;
         const currentTime = Date.now();

         if (expiryTime <= currentTime) {
            logout();
         } else {
            if (logoutTimer.current) {
               clearTimeout(logoutTimer.current);
            }
            const timeout = expiryTime - currentTime;
            logoutTimer.current = setTimeout(() => {
               logout();
            }, timeout);
         }
      } catch (err) {
         logout();
      }
   };

   const login = (data) => {
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setUser(data.user);
      handleToken(data.token);
   };

   return (
      <AuthContext.Provider value={{ user, login, logout, loading }}>
         {children}
      </AuthContext.Provider>
   );
};